import React from "react";
import { Form, Col, Row } from "react-bootstrap";
import PropTypes from 'prop-types';
import { Button, useMediaQuery } from '@material-ui/core';
import { SelectInput, TextInput } from "../../../../Helpers/Inputs";
import { InputMaskPhone, InputMaskSSN, InputMaskDate } from "../../../../Helpers/Formatters";
import StatesWithDisabled from '../../../../Helpers/Lists/StatesWithDisabled';

export default function BeneficiaryForm(props) {
  const isDesktopLabel = useMediaQuery('(min-width:576px)');

  const getRelationshipSelectOptions = () => {
    if (props.isJuvenile === true){
      return (
        [
          { value: "20", label: "Parent" },
          { value: "50", label: "Grandparent" }
        ]
      );
    }

    return (
      [
        { value: "13", label: "Child" },
        { value: "20", label: "Parent" },
        { value: "10", label: "Domestic Partner" },
        { value: "50", label: "Grandparent" },
        { value: "9", label: "Spouse" },
        { value: "18", label: "Sibling" },
        { value: "2", label: "Estate of the Insured" },
      ]
    );
  };

  const onFieldChange = (field, value) => {
    // call onChange with the whole updated form
    props.onChange({ ...props.formState, [field]: value });
  };

  // manually call setValue for fields that don't play nice with react-hook-form register
  const handleValueChange = (field, value, longFieldName) => {
    props.setValue(longFieldName, value);
    onFieldChange(field, value);
    props.trigger(longFieldName);
  };

  return (
    <div className="m-2 p-2">
      <Form.Group>
        <TextInput
          name={`beneficiaries[${props.index}].firstName`}
          id={`beneficiaries[${props.index}].firstName`}
          label="First Name"
          defaultValue={props.formState.firstName}
          errors={props.errors && props.errors.firstName}
          inputRef={props.register}
          onChange={(e) => onFieldChange('firstName', e.target.value)}
        />
      </Form.Group>

      <Form.Group>
        <TextInput
          name={`beneficiaries[${props.index}].middleInitial`}
          id={`beneficiaries[${props.index}].middleInitial`}
          label="Middle Initial"
          defaultValue={props.formState.middleInitial}
          errors={props.errors && props.errors.middleInitial}
          inputRef={props.register}
          onChange={(e) => onFieldChange('middleInitial', e.target.value)}
        />
      </Form.Group>

      <Form.Group>
        <TextInput
          name={`beneficiaries[${props.index}].lastName`}
          id={`beneficiaries[${props.index}].lastName`}
          label="Last Name"
          defaultValue={props.formState.lastName}
          errors={props.errors && props.errors.lastName}
          inputRef={props.register}
          onChange={(e) => onFieldChange('lastName', e.target.value)}
        />
      </Form.Group>

      <Form.Group>
        <TextInput
          name={`beneficiaries[${props.index}].address`}
          id={`beneficiaries[${props.index}].address`}
          label="Address 1"
          defaultValue={props.formState.address}
          errors={props.errors && props.errors.address}
          inputRef={props.register}
          onChange={(e) => onFieldChange('address', e.target.value)}
        />
      </Form.Group>

      <Form.Group>
        <TextInput
          name={`beneficiaries[${props.index}].address2`}
          id={`beneficiaries[${props.index}].address2`}
          label="Address 2 (Apt/Suite/Etc)"
          defaultValue={props.formState.address2}
          errors={props.errors && props.errors.address2}
          inputRef={props.register}
          onChange={(e) => onFieldChange('address2', e.target.value)}
        />
      </Form.Group>

      <Form.Group>
        <TextInput
          name={`beneficiaries[${props.index}].city`}
          id={`beneficiaries[${props.index}].city`}
          label="City"
          defaultValue={props.formState.city}
          errors={props.errors && props.errors.city}
          inputRef={props.register}
          onChange={(e) => onFieldChange('city', e.target.value)}
        />
      </Form.Group>

      <Row>
        <Col>
          <Form.Group>
            <SelectInput
              name={`beneficiaries[${props.index}].state`}
              id={`beneficiaries[${props.index}].state`}
              defaultValue={props.formState.state}
              onChange={e => handleValueChange('state', e.target.value, `beneficiaries[${props.index}].state`)}
              label="State"
              selectOptions={StatesWithDisabled(props.unavailableStates)}
              errors={props.errors && props.errors.state}
              inputRef={props.register}
            />
          </Form.Group>
        </Col>

        <Col>
          <Form.Group>
            <TextInput
              name={`beneficiaries[${props.index}].zip`}
              id={`beneficiaries[${props.index}].zip`}
              label="Zip"
              defaultValue={props.formState.zip}
              errors={props.errors && props.errors.zip}
              inputRef={props.register}
              onChange={(e) => onFieldChange('zip', e.target.value)}
            />
          </Form.Group>
        </Col>
      </Row>

      <Form.Group>
        <TextInput
          name={`beneficiaries[${props.index}].phone`}
          id={`beneficiaries[${props.index}].phone`}
          label="Phone Number"
          defaultValue={props.formState.phone}
          errors={props.errors && props.errors.phone}
          inputRef={props.register}
          onChange={(e) => onFieldChange('phone', e.target.value)}
          InputProps={{
            inputComponent: InputMaskPhone,
          }}
        />
      </Form.Group>

      <Form.Group>
        <TextInput
          name={`beneficiaries[${props.index}].email`}
          id={`beneficiaries[${props.index}].email`}
          label="Email"
          defaultValue={props.formState.email}
          errors={props.errors && props.errors.email}
          inputRef={props.register}
          onChange={(e) => onFieldChange('email', e.target.value)}
        />
      </Form.Group>

      <Form.Group>
        <TextInput
          name={`beneficiaries[${props.index}].birthdate`}
          id={`beneficiaries[${props.index}].birthdate`}
          label="Date of Birth"
          defaultValue={props.formState.birthdate}
          errors={props.errors && props.errors.birthdate}
          inputRef={props.register}
          onChange={(e) => onFieldChange('birthdate', e.target.value)}
          InputProps={{
            inputComponent: InputMaskDate,
          }}
        />
      </Form.Group>

      <Form.Group>
        <TextInput
          name={`beneficiaries[${props.index}].ssn`}
          id={`beneficiaries[${props.index}].ssn`}
          label={`${isDesktopLabel ? "Social Security Number (Optional)" : "SSN (Optional)"}`}
          defaultValue={props.formState.ssn}
          errors={props.errors && props.errors.ssn}
          inputRef={props.register}
          onChange={(e) => onFieldChange('ssn', e.target.value)}
          InputProps={{
            inputComponent: InputMaskSSN,
          }}
        />
      </Form.Group>

      <Form.Group>
        <SelectInput
          name={`beneficiaries[${props.index}].beneficiaryType`}
          id={`beneficiaries[${props.index}].beneficiaryType`}
          defaultValue={props.formState.beneficiaryType}
          onChange={e => handleValueChange('beneficiaryType', e.target.value, `beneficiaries[${props.index}].beneficiaryType`)}
          label="Beneficiary Class"
          selectOptions={[{ value: "Primary", label: "Primary" }, { value: "Contingent", label: "Contingent" }]}
          errors={props.errors && props.errors.beneficiaryType}
          inputRef={props.register}
        />
      </Form.Group>

      <Form.Group>
        <SelectInput
          name={`beneficiaries[${props.index}].relationship`}
          id={`beneficiaries[${props.index}].relationship`}
          defaultValue={props.formState.relationship}
          onChange={e => handleValueChange('relationship', e.target.value, `beneficiaries[${props.index}].relationship`)}
          label="Relationship"
          selectOptions={getRelationshipSelectOptions()}
          inputRef={props.register}
          errors={props.errors && props.errors.relationship}
        />
      </Form.Group>

      <Form.Group>
        <TextInput
          name={`beneficiaries[${props.index}].percentage`}
          id={`beneficiaries[${props.index}].percentage`}
          label="Percentage"
          defaultValue={props.formState.percentage}
          errors={props.errors && props.errors.percentage}
          inputRef={props.register}
          onChange={(e) => onFieldChange('percentage', e.target.value)}
        />
      </Form.Group>

      {props.isRemove && (
        <Form.Group>
          <Button onClick={props.onRemove}>Remove this Beneficiary</Button>
        </Form.Group>
      )}
      <hr/>
    </div >
  );
}
BeneficiaryForm.propTypes = {
  formState: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  setValue: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
  register: PropTypes.func.isRequired,
  errors: PropTypes.any,
  unavailableStates: PropTypes.array,
  isJuvenile: PropTypes.bool,
  trigger: PropTypes.func,
  onRemove: PropTypes.func,
  isRemove: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./src/components/Quoters/Securian/WL/steps/BeneficiaryForm.js